import type { Flags } from '@widget/core';
import type { WidgetItemSchema } from '../schemas';

export const getFlagsFromResponse = (
  response: ReturnType<typeof WidgetItemSchema.parse>,
): Flags => {
  return {
    personalization: !!response?.content?.personalization,
    enableReset: !!response?.content?.enableReset,
    showLocalizedUSP: !!response?.content?.showLocalizedUSP,
    isSearchProfile: !!response?.content?.isSearchProfile,
    exludeLocalizedUspForMarkets: response?.content?.exludeLocalizedUspForMarkets,
    agentCityPrefix: response?.content?.agentCityPrefix,
    enableExitPopup: !!response?.content?.enableExitPopup,
  };
};
